import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AvailableDelearService } from 'projects/Widget/src/app/business-entities/available-service';
import { CommonService } from 'projects/Widget/src/app/services/commom.service';
import { WidgetCustomerVehicleDetails } from '../../../../business-entities/widget-customer-vehicle-details-model';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';

@Component({
  selector: 'app-map',
  templateUrl: 'map.component.html'
})
export class MapComponent {
  @Input() latitude: number;
  @Input() longitude: number;
  @Input() preferedDealer: AvailableDelearService;

  public origin: google.maps.LatLngLiteral;
  public destination: google.maps.LatLngLiteral;
  public distanceInKm: number;
  public markerOptions: any;

  selectedCustomerVehicleDetails: WidgetCustomerVehicleDetails;
  PIx = 3.141592653589793;
  RADIUS = 6378.16;

  public renderOptions = {
    suppressMarkers: true,
  };

  Radians(x: number): number {
    return x * this.PIx / 180;
  }

  Degrees(x: number): number {
    return x * 180 / this.PIx;
  }

  constructor(public activeModal: NgbActiveModal, private commonService: CommonService) {}

  ngOnInit(): void {
    this.loadGoogleMapsScript();
    this.selectedCustomerVehicleDetails = this.commonService.getSelectedCustomerVehicleDetails();
    this.markerOptions = {
      origin: {
        label: 'C',
        infoWindow: `<div class="infoWindowContent">
          <h3><b>Your Location</b></h3>
          ${this.selectedCustomerVehicleDetails.ADDRESS_LINE_1 ? this.selectedCustomerVehicleDetails.ADDRESS_LINE_1 + ",&nbsp" : ""}
          ${this.selectedCustomerVehicleDetails.ADDRESS_LINE_2 ? this.selectedCustomerVehicleDetails.ADDRESS_LINE_2 + ",<br>" : ""}
          ${this.selectedCustomerVehicleDetails.CITY ? this.selectedCustomerVehicleDetails.CITY + ",&nbsp" : ""}
          ${this.selectedCustomerVehicleDetails.STATE ? this.selectedCustomerVehicleDetails.STATE + ",<br>" : ""}
          ${this.selectedCustomerVehicleDetails.PINCODE ? this.selectedCustomerVehicleDetails.PINCODE + ",&nbsp" : ""}
          ${this.selectedCustomerVehicleDetails.COUNTRY ? this.selectedCustomerVehicleDetails.COUNTRY : ""}
        </div>`
      },
      destination: {
        label: 'D',
        infoWindow: `<div class="infoWindowContent">
          <h3><b>Selected Dealer Location</b></h3>
          <h4>${this.preferedDealer.dealerName}</h4>
          ${this.preferedDealer.address ? this.preferedDealer.address + ",<br>" : ""}
          ${this.preferedDealer.city ? this.preferedDealer.city + ",&nbsp" : ""}
          ${this.preferedDealer.state ? this.preferedDealer.state + ",<br>" : ""}
          ${this.preferedDealer.pincode ? this.preferedDealer.pincode + ",&nbsp" : ""}
          ${this.preferedDealer.country ? this.preferedDealer.country : ""}
        </div>`
      }
    };
    this.getDirection();
  }

  getDirection(): void {
    this.origin = { 
      lat: this.selectedCustomerVehicleDetails.latitude, 
      lng: this.selectedCustomerVehicleDetails.longitude 
    };
    this.destination = { 
      lat: this.latitude, 
      lng: this.longitude 
    };
    this.distanceInKm = this.preferedDealer.distance;
  }
  

  loadGoogleMapsScript() {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${EnvSetting.googleKey}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }
}
